'use client';

import _defineProperty from "/codebuild/output/src2703/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src2703/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["classNames", "styles", "unstyled", "children", "store", "vars", "onOptionSubmit", "onClose", "size", "dropdownPadding", "resetSelectionOnOptionHover", "__staticSelector", "readOnly"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { rem } from '../../core/utils/units-converters/rem.mjs';
import 'react';
import { getFontSize, getSize } from '../../core/utils/get-size/get-size.mjs';
import '@mantine/hooks';
import { createVarsResolver } from '../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { useStyles } from '../../core/styles-api/use-styles/use-styles.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
import { Popover } from '../Popover/Popover.mjs';
import '../Popover/PopoverDropdown/PopoverDropdown.mjs';
import '../Popover/PopoverTarget/PopoverTarget.mjs';
import { ComboboxProvider } from './Combobox.context.mjs';
import { ComboboxChevron } from './ComboboxChevron/ComboboxChevron.mjs';
import { ComboboxClearButton } from './ComboboxClearButton/ComboboxClearButton.mjs';
import { ComboboxDropdown } from './ComboboxDropdown/ComboboxDropdown.mjs';
import { ComboboxDropdownTarget } from './ComboboxDropdownTarget/ComboboxDropdownTarget.mjs';
import { ComboboxEmpty } from './ComboboxEmpty/ComboboxEmpty.mjs';
import { ComboboxEventsTarget } from './ComboboxEventsTarget/ComboboxEventsTarget.mjs';
import { ComboboxFooter } from './ComboboxFooter/ComboboxFooter.mjs';
import { ComboboxGroup } from './ComboboxGroup/ComboboxGroup.mjs';
import { ComboboxHeader } from './ComboboxHeader/ComboboxHeader.mjs';
import { ComboboxHiddenInput } from './ComboboxHiddenInput/ComboboxHiddenInput.mjs';
import { ComboboxOption } from './ComboboxOption/ComboboxOption.mjs';
import { ComboboxOptions } from './ComboboxOptions/ComboboxOptions.mjs';
import { ComboboxSearch } from './ComboboxSearch/ComboboxSearch.mjs';
import { ComboboxTarget } from './ComboboxTarget/ComboboxTarget.mjs';
import { useCombobox } from './use-combobox/use-combobox.mjs';
import classes from './Combobox.module.css.mjs';
var defaultProps = {
  keepMounted: true,
  withinPortal: true,
  resetSelectionOnOptionHover: false,
  width: "target",
  transitionProps: {
    transition: "fade",
    duration: 0
  }
};
var varsResolver = createVarsResolver(function (_, _ref) {
  var size = _ref.size,
    dropdownPadding = _ref.dropdownPadding;
  return {
    options: {
      "--combobox-option-fz": getFontSize(size),
      "--combobox-option-padding": getSize(size, "combobox-option-padding")
    },
    dropdown: {
      "--combobox-padding": dropdownPadding === void 0 ? void 0 : rem(dropdownPadding),
      "--combobox-option-fz": getFontSize(size),
      "--combobox-option-padding": getSize(size, "combobox-option-padding")
    }
  };
});
function Combobox(_props) {
  var props = useProps("Combobox", defaultProps, _props);
  var classNames = props.classNames,
    styles = props.styles,
    unstyled = props.unstyled,
    children = props.children,
    controlledStore = props.store,
    vars = props.vars,
    onOptionSubmit = props.onOptionSubmit,
    onClose = props.onClose,
    size = props.size,
    dropdownPadding = props.dropdownPadding,
    resetSelectionOnOptionHover = props.resetSelectionOnOptionHover,
    __staticSelector = props.__staticSelector,
    readOnly = props.readOnly,
    others = _objectWithoutProperties(props, _excluded);
  var uncontrolledStore = useCombobox();
  var store = controlledStore || uncontrolledStore;
  var getStyles = useStyles({
    name: __staticSelector || "Combobox",
    classes: classes,
    props: props,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    vars: vars,
    varsResolver: varsResolver
  });
  var onDropdownClose = function onDropdownClose() {
    onClose === null || onClose === void 0 || onClose();
    store.closeDropdown();
  };
  return /* @__PURE__ */jsx(ComboboxProvider, {
    value: {
      getStyles: getStyles,
      store: store,
      onOptionSubmit: onOptionSubmit,
      size: size,
      resetSelectionOnOptionHover: resetSelectionOnOptionHover,
      readOnly: readOnly
    },
    children: /* @__PURE__ */jsx(Popover, _objectSpread(_objectSpread({
      opened: store.dropdownOpened
    }, others), {}, {
      onClose: onDropdownClose,
      withRoles: false,
      unstyled: unstyled,
      children: children
    }))
  });
}
var extendCombobox = function extendCombobox(c) {
  return c;
};
Combobox.extend = extendCombobox;
Combobox.classes = classes;
Combobox.displayName = "@mantine/core/Combobox";
Combobox.Target = ComboboxTarget;
Combobox.Dropdown = ComboboxDropdown;
Combobox.Options = ComboboxOptions;
Combobox.Option = ComboboxOption;
Combobox.Search = ComboboxSearch;
Combobox.Empty = ComboboxEmpty;
Combobox.Chevron = ComboboxChevron;
Combobox.Footer = ComboboxFooter;
Combobox.Header = ComboboxHeader;
Combobox.EventsTarget = ComboboxEventsTarget;
Combobox.DropdownTarget = ComboboxDropdownTarget;
Combobox.Group = ComboboxGroup;
Combobox.ClearButton = ComboboxClearButton;
Combobox.HiddenInput = ComboboxHiddenInput;
export { Combobox };